import * as Sentry from '@sentry/react';
import 'App.scss';
import Config from 'config';
import i18next from 'i18next';
import $$app from 'models/app';
import { Suspense, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import Alerts from 'components/Alerts/Alerts';
import RouterApp from 'components/Apps/RouterApp';
import Modality from 'components/Modals/Modality';
import RouterGateRoot from 'components/RouterGateRoot/RouterGateRoot';
import SentryFallbackComponent from 'components/SentryFallbackComponent/SentryFallbackComponent';
import LoadingPage from 'components/pages/LoadingPage/LoadingPage';

import theme from 'constants/theme-constants';

import APIHelper from 'utils/api-helper';

import useInterval from 'hooks/useInterval';
import useMarketingModalStates from 'hooks/useMarketingModalStates';

APIHelper.setupInterceptors();

/*
    TODO:
    --------------------------------------------------------------------------------------------------------------------
    Bugs, bad practices, and other things to fix:
    --------------------------------------------------------------------------------------------------------------------
    [x] - Get rid of TempApi
    [-] - Replace some useEventListener with effector events
    [-] - Make strongly types modals service with types modal props and states (continue developing modals-util)
    [-] - Add eslint rules to prevent using any
    [-] - Add eslint rules to prevent using css colors as strings (need to use css variables as it's possible to use in both styled-components and scss files)
    [x] - Get rid of linkTo function. Use useNavigate hook instead
    
    --------------------------------------------------------------------------------------------------------------------
    Optimizations, improvements, using best practices:
    --------------------------------------------------------------------------------------------------------------------
    [-] - Create strongly typed storage
    [-] - Separate stores
    [-] - Optimize list of production dependencies
    [-] - Reduce number of dependencies if possible
    [-] - Move pages components from "components" to "pages" folder and vice versa
    [-] - Move static folder content to assets folder instead
    [-] - Create code-style docs
*/

const App = () => {
    useInterval(i18next.reloadResources, Config.application.resourcesReloadIntervalMin * 60 * 1000);
    useMarketingModalStates();

    useEffect(() => {
        $$app.appLoaded();
    }, []);

    return (
        // @ts-ignore
        <Sentry.ErrorBoundary fallback={SentryFallbackComponent}>
            <BrowserRouter>
                <ThemeProvider theme={theme}>
                    <Modality />
                    <RouterGateRoot />
                    <Alerts />

                    <Suspense fallback={<LoadingPage />}>
                        <RouterApp />
                    </Suspense>
                </ThemeProvider>
            </BrowserRouter>
        </Sentry.ErrorBoundary>
    );
};

export default App;
